import React, { useState } from "react";
import {
  FormControl,
  IconButton,
  InputAdornment,
  TextField,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { BLUE_EIGHT } from "../../../theme";
import { useTranslation } from "react-i18next";
import { VisibilityOffIcon, VisibilityOnIcon } from "../../../assets/svg";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),

      "& .MuiOutlinedInput-root": {
        borderRadius: 10,

        "& .MuiInputBase-input": {
          fontFamily: "Montserrat, sans-serif",
        },
      },
    },
  },
}));

export const TextFieldComponent = ({
  error = false,
  label,
  onChange,
  required = false,
  disabled = false,
  value,
  type = "text",
  name,
  errorMessage = false,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const [showPassword, setShowPassword] = useState(false);

  const handleMouseDownPassword = (event) => event.preventDefault();

  let today = new Date();
  let dd = String(today.getDate()).padStart(2, "0");
  let mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0
  let yyyy = today.getFullYear();
  today = yyyy + "-" + mm + "-" + dd;

  return (
    <FormControl
      className={classes.root}
      variant="outlined"
      fullWidth
      error={error}
    >
      <TextField
        required={required}
        color={BLUE_EIGHT}
        label={label}
        type={type === "password" && showPassword ? "text" : type}
        value={value}
        disabled={disabled}
        id="text-input"
        size="small"
        variant="outlined"
        onChange={onChange(name)}
        InputLabelProps={{ shrink: true }}
        InputProps={{
          endAdornment:
            type === "password" ? (
              <InputAdornment position="start">
                <IconButton
                  aria-label="toggle password visibility"
                  style={{
                    fontSize: "13px",
                    height: "20px",
                    width: "45px",
                    fontWeight: "bold",
                    color: "#006E7D",
                    paddingBottom: 20,
                  }}
                  onClick={() => setShowPassword(!showPassword)}
                  onMouseDown={handleMouseDownPassword}
                  edge="start"
                >
                  {showPassword ? <VisibilityOnIcon /> : <VisibilityOffIcon />}
                </IconButton>
              </InputAdornment>
            ) : (
              ""
            ),
          inputProps: { max: type === "date" ? today : undefined },
        }}
      />
      <span style={{ fontSize: "0.65vw", paddingLeft: 10, color: "red" }}>
        {errorMessage}
      </span>
    </FormControl>
  );
};
